import React, { useState } from 'react';
import clsx from 'clsx';
import FsLightbox from 'fslightbox-react';
import Image from 'next/image';

import { BaseComponentProps } from '@utils/types/baseComponents';

import { Play } from '@assets/icons';

import styles from './styles.module.scss';

type Props = {
  src: string;
  thumbnail?: string;
} & BaseComponentProps;

VideoPlayer.defaultProps = {};

export function VideoPlayer(props: Props) {
  const { containerStyle, src, thumbnail } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setOpen((v) => !v)}
        className={clsx([styles.videoPlayerContainer, containerStyle])}
      >
        {!!thumbnail && (
          <Image src={thumbnail} alt="Video tour thumbnail" layout="fill" />
        )}
        <div className={styles.playButton}>
          <Play />
        </div>
      </div>
      <FsLightbox
        toggler={open}
        sources={[src]}
        types={['youtube']}
        showThumbsOnMount
      />
    </>
  );
}
